@if (displayToast) {
  <div id="toast">
    <app-toast toastStyle="positive" icon="checkmark" [text]="successResponse">
    </app-toast>
  </div>
}
<div id="title--container">
  <h4>Create an organisation</h4>
  <h5>{{ laboratory?.laboratoryName }}</h5>
</div>
<hr />
<div id="org--container">
  <div class="body1">
    Please complete the details below to add a new organisation.
  </div>
  <h6>Organisation Details</h6>
  <form [formGroup]="addOrgForm">
    <div class="top-row">
      <app-underlined-form-field
        [parentForm]="addOrgForm"
        [field]="orgNameField"
      ></app-underlined-form-field>
      <app-underlined-dropdown-form-field
        [field]="licenseField"
        [parentForm]="addOrgForm"
      ></app-underlined-dropdown-form-field>
      <div class="license-info-box">
        <div class="info-stat">
          <span class="info-stat-label">Users</span>
          <span class="info-stat-value">{{
            selectedLicenseTypeUsers != null ? selectedLicenseTypeUsers : "–"
          }}</span>
        </div>
        <div class="info-divider"></div>
        <div class="info-stat">
          <span class="info-stat-label">Devices</span>
          <span class="info-stat-value">{{
            selectedLicenseTypeDevices != null
              ? selectedLicenseTypeDevices
              : "–"
          }}</span>
        </div>
      </div>
    </div>
    <h6>Super User Details</h6>
    <div class="bottom-row">
      <app-underlined-form-field
        [parentForm]="addOrgForm"
        [field]="superUserFirstNameField"
      ></app-underlined-form-field>
      <app-underlined-form-field
        [parentForm]="addOrgForm"
        [field]="superUserLastNameField"
      ></app-underlined-form-field>
      <app-underlined-form-field
        [parentForm]="addOrgForm"
        [field]="superUserEmailField"
      ></app-underlined-form-field>
    </div>
    <div id="button--container">
      <app-button
        label="Add Organisation"
        buttonId="add-btn"
        (buttonClicked)="onSubmit()"
        [isDisabled]="addOrgForm.invalid"
        [isProcessing]="isProcessing"
      >
      </app-button>
    </div>
  </form>
</div>
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error?.message"
  primaryButtonText="close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="attention"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
